export default "__VITE_ASSET__Brdc$2Fv__"